import { Collapse, Typography } from "@mui/material";
import Alert, { AlertProps } from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import { Cross } from "akar-icons";
import React, { useState } from "react";
import styled from "styled-components";

import { prefixClassName } from "@smartrr/shared/components/primitives/index";

interface IToastProps extends AlertProps {
  autoClose?: boolean;
}

const Toast = styled(Alert).attrs(props => ({
  ...props,
  className: prefixClassName("info-toast"),
}))`
  background-color: #202223;
  color: #fff;
  border-radius: 8px 8px 0px 0px;
  padding: 20px;
  height: 65px;
  z-index: 20;
  &.MuiAlert-standardError {
    background-color: #c61e00;
  }
  & .MuiAlert-message {
    padding: 0px;
  }
  & .MuiAlert-action {
    margin-right: -2px;
    padding: 0px;
  }
  h4 {
    margin: 0px;
  }
`;

export const AquariusToast = ({ autoClose, ...props }: IToastProps): JSX.Element => {
  const [open, setOpen] = useState(true);
  autoClose = autoClose || false;

  autoClose &&
    setTimeout(() => {
      setOpen(false);
    }, 2000) /**Set alert duration here */;

  return (
    <Collapse in={open}>
      <Toast
        severity={props.severity}
        icon={false}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              setOpen(false);
            }}
          >
            <Cross strokeWidth={2} size={17} color={"#fff"} />
          </IconButton>
        }
      >
        <Typography variant="h4">{props.children}</Typography>
      </Toast>
    </Collapse>
  );
};
